import { render, staticRenderFns } from "./QuestionSetting.vue?vue&type=template&id=ac935896&"
import script from "./QuestionSetting.vue?vue&type=script&lang=js&"
export * from "./QuestionSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports